export const FormInputSources = [
  { keyword: 'auto', icon: 'autoIcon', label: 'automatic' },
  { keyword: 'probe', icon: 'probeIcon', label: 'bluetooth_probe' },
  { keyword: 'manual', icon: 'manualIcon', label: 'manual' },
] as const;

export type InputSource = (typeof FormInputSources)[0];
